<template>
  <ApexChart type="donut" :options="chartOptions" :series="series"></ApexChart>
</template>

<script>
export default {
  name: "DonutChart",
  data() {
    return {
      series: [44, 55],
      chartOptions: {
        chart: {
          type: "donut",
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// DonutChart.vue?53155d02